var exports = {
  "k": "VoiceParticipantsList.module__container___NktZb0",
};

module.exports = exports;
